<template>
    <div>
        <el-dialog title="车辆基础信息" :visible.sync="dialogVisible" width="80%" :modal-append-to-body="false">
            <el-descriptions title="" :column="3">
                <el-descriptions-item label="公司名称">{{detail.enterpriseName}}</el-descriptions-item>
                <el-descriptions-item label="车牌号码">{{detail.vehicleNumber}}</el-descriptions-item>
                <el-descriptions-item label="车牌颜色">{{detail.licensePlateColor}}</el-descriptions-item>
                <el-descriptions-item label="核定载客位">{{detail.passengerCapacity}}</el-descriptions-item>
                <el-descriptions-item label="车辆厂牌">{{detail.brand}}</el-descriptions-item>
                <el-descriptions-item label="车辆型号">{{detail.brandModel}}</el-descriptions-item>
                <el-descriptions-item label="车辆类型">{{detail.vehicleType}}</el-descriptions-item>
                <el-descriptions-item label="所属车主">{{detail.driverName}}</el-descriptions-item>
                <el-descriptions-item label="车身颜色">{{detail.vehicleColor}}</el-descriptions-item>
                <el-descriptions-item label="发动机号">{{detail.engineNumber}}</el-descriptions-item>
                <el-descriptions-item label="车辆VIN码">{{detail.vin}}</el-descriptions-item>
                <el-descriptions-item label="车辆注册日期">{{detail.registrationDate}}</el-descriptions-item>
                <el-descriptions-item label="车辆燃料类型">{{detail.fuelType}}</el-descriptions-item>
                <el-descriptions-item label="发动机排量">{{detail.engineCapacity}}</el-descriptions-item>
                <el-descriptions-item label="车辆运输证发证机构">{{detail.transportLicenseIssuingAuthority}}</el-descriptions-item>
                <el-descriptions-item label="车辆经营区域">{{detail.operatingArea}}</el-descriptions-item>
                <el-descriptions-item label="运输证字号">{{detail.transportCertificateNumber}}</el-descriptions-item>
                <el-descriptions-item label="车辆运输证有效期起">{{detail.transportCertificateStart}}</el-descriptions-item>
                <el-descriptions-item label="车辆运输证有效期止">{{detail.transportCertificateEnd}}</el-descriptions-item>
                <el-descriptions-item label="车辆初次登记日期">{{detail.initialRegistrationTime}}</el-descriptions-item>
                <el-descriptions-item label="车辆检修状态">{{detail.vehicleMaintenanceStatus}}</el-descriptions-item>
                <el-descriptions-item label="车辆年度审验状态">{{detail.annualReviewStatus}}</el-descriptions-item>
                <el-descriptions-item label="卫星定位装置品牌">{{detail.gpsBrand}}</el-descriptions-item>
                <el-descriptions-item label="卫星定位装置型号">{{detail.gpsModel}}</el-descriptions-item>
                <el-descriptions-item label="卫星定位装置IMEI号">{{detail.gpsImei}}</el-descriptions-item>
                <el-descriptions-item label="卫星定位设备安装日期">{{detail.gpsInstallationDate}}</el-descriptions-item>
                <el-descriptions-item label="注册日期">{{detail.registrationDate}}</el-descriptions-item>
                <el-descriptions-item label="营运类型">{{detail.operateType}}</el-descriptions-item>
                <el-descriptions-item label="运价类型编码">{{detail.rateTypeNumber}}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        detail: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            dialogVisible: false
        };
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {
        closeClick() {
            this.dialogVisible = false
        }
    },
};
</script>
<style scoped lang="less">
::v-deep .el-descriptions .el-descriptions-item__cell {
    padding-bottom: 20px;
}
</style>